import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

// ui-kit
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'

// mixins
import { Divider, Follow, IconContainer } from './mixins'

// constants
import { SITE_ID } from '../../../../../../constants'
import features from '../../../../../../constants/features-per-country'

// utils
import { userLoggedIn } from '../../../../../../utils/cookies'

// redux
import {
  dejarDeSeguirEmpresa,
  postDeleteSeguirEmpresaReset,
  seguirEmpresa,
} from '../../../../../../redux/actions/company-summary'
import { StatusType } from '../../../../../../redux/types/status'
import { showSnackbar, showSnackbarError } from '../../../../../../redux/actions/applicant/curriculum/snackbar'

interface SeguirEmpresaLinkProps {
  aviso: {
    empresa: {
      id: number
      confidencial: boolean
    }
    origenAviso: string
  }
  isMenu?: boolean
  siguiendo: boolean
  siguiendoStates: StatusType
  getSiguiendoStates: StatusType
}

const seguirEmpresaEnabled = features[SITE_ID || 'BMAR'].seguirEmpresa.enabled

const SeguirEmpresaLink = ({
  aviso,
  isMenu = false,
  siguiendo,
  siguiendoStates,
  getSiguiendoStates,
}: SeguirEmpresaLinkProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isUserLogged = userLoggedIn()
  const history = useHistory()
  const empresaId = aviso?.empresa.id
  const isZonaJobs = aviso && aviso.origenAviso === 'ZONAJOBS'
  const showSeguir = seguirEmpresaEnabled && !aviso?.empresa.confidencial && empresaId && !isZonaJobs

  const [label, setLabel] = useState()

  const getVariant = () => {
    if (isMenu) return 'black'
    return siguiendo ? 'secondary' : 'primary'
  }

  const getVariantText = () => {
    if (isMenu) return 'gray84'
    return siguiendo ? 'secondary' : 'primary'
  }

  const seguirEmpresaHandler = () => {
    if (!isUserLogged) {
      history.push(`/login?returnTo=${window.location.pathname}`)
      return
    }

    if (siguiendo) {
      dispatch(dejarDeSeguirEmpresa(empresaId))
    } else {
      dispatch(seguirEmpresa(empresaId))
    }
  }

  const setDejarDeSeguirText = () => {
    if (siguiendo) {
      setLabel(t('fichaAviso.acciones.dejarDeSeguir'))
    }
  }

  const setSiguiendoText = () => {
    setLabel(t(siguiendo ? 'fichaAviso.acciones.siguiendo' : 'fichaAviso.acciones.seguir'))
  }

  useEffect(() => {
    setSiguiendoText()
  }, [siguiendo])

  useEffect(() => {
    if (siguiendoStates.success) {
      if (siguiendo) {
        dispatch(showSnackbar(t('saveCompany.snackbar.seguir'), 'icon-light-heart'))
      } else {
        dispatch(showSnackbar(t('saveCompany.snackbar.dejarDeSeguir'), 'icon-light-trash-2'))
      }
      dispatch(postDeleteSeguirEmpresaReset())
    }
    if (siguiendoStates.error) {
      dispatch(showSnackbarError('Ocurrió un error inesperado.'))
      dispatch(postDeleteSeguirEmpresaReset())
    }
  }, [siguiendoStates])

  return (
    showSeguir && (
      <>
        {!isMenu && <Divider />}

        <Follow
          onClick={seguirEmpresaHandler}
          onFocus={setDejarDeSeguirText}
          onMouseEnter={setDejarDeSeguirText}
          onMouseLeave={setSiguiendoText}
          disabled={getSiguiendoStates.loading}
          buttonoptions={{ size: 'small', variant: getVariant(), type: 'link' }}
          underline={!isMenu && !siguiendo}
          isMenu={isMenu}
        >
          <IconContainer addGap={isMenu ? '12px' : '4px'}>
            <Icon name={siguiendo ? 'icon-bold-heart' : 'icon-light-heart'} size={isMenu ? '16' : '14'} />
            <Text size="sm" fontWeight="semibold" variant={getVariantText()}>
              {label}
            </Text>
          </IconContainer>
        </Follow>
      </>
    )
  )
}

const mapStateToProps = ({ companySummaryStore }) => ({
  siguiendo: companySummaryStore?.siguiendo,
  siguiendoStates: companySummaryStore?.siguiendoStates,
  getSiguiendoStates: companySummaryStore?.getSiguiendoStates,
})

export default connect(mapStateToProps)(SeguirEmpresaLink as React.FC<SeguirEmpresaLinkProps>)
